import React from 'react';
import { Text } from '@carnica/ui-kit';
import { useIsMobileDimension } from '@carnica/utils/hooks';
import classNames from 'classnames/bind';
import styles from "./styles.pcss";
var cn = classNames.bind(styles);
export var Address = function Address(_ref) {
  var address = _ref.address,
    className = _ref.className;
  var isMobile = useIsMobileDimension();
  return /*#__PURE__*/React.createElement(Text, {
    className: cn('address', className),
    variant: isMobile ? 'body-small' : 'body-medium',
    "data-t-id": "components-Address"
  }, address);
};